/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDetailsChangeRequest as ModelsCustomerCustomerDetailsChangeRequest } from '../../models/Models/Customer/customer-details-change-request';
import { CustomerDetailsResponse as ModelsCustomerCustomerDetailsResponse } from '../../models/Models/Customer/customer-details-response';

export interface V4CustomersMeDetailsPut$Xml$Xml$Params {
      body?: ModelsCustomerCustomerDetailsChangeRequest
}

export function v4CustomersMeDetailsPut$Xml$Xml(http: HttpClient, rootUrl: string, params?: V4CustomersMeDetailsPut$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeDetailsPut$Xml$Xml.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/*+xml');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerDetailsResponse>;
    })
  );
}

v4CustomersMeDetailsPut$Xml$Xml.PATH = '/v4/customers/me/details';
